import s from 'pages/common.module.scss'
import DisplayMode from 'interfaces/DisplayMode'
import FiltresSection from 'pages/BiensAVendre/components/ResultatsdeRecherche/components/FiltresSection/FiltresSection'
import ActionsResultatSection from './components/ActionsResultatSection/ActionsResultatSection'
import ResultatListeSection from './components/ResultatListeSection/ResultatListeSection'
import ActionsResultatSectionV2 from './components/ActionsResultatSectionV2/ActionsResultatSectionV2'

interface Props {
  displayMode: DisplayMode
}

const releaseToggleV2 = process?.env?.REACT_APP_RELEASE_TOGGLE_V2 === 'true'

const ResultatsDeRecherche = ({ displayMode }: Props): JSX.Element | null => {
  if (displayMode.type === 'synthese') {
    return (
      <>
        <div className={s.sectionFiltresEtNavigation}>
          {releaseToggleV2 ? (
            <ActionsResultatSectionV2 />
          ) : (
            <ActionsResultatSection />
          )}

          {releaseToggleV2 && <FiltresSection />}
        </div>
        <ResultatListeSection />
      </>
    )
  }
  return null
}

export default ResultatsDeRecherche
